import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import Navbar from '../navbar/Navbar';
import './styles.css';
import { useNavigate } from 'react-router-dom';

const Leaderboard = () => {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUsers = JSON.parse(localStorage.getItem('users')) || [];
    const sortedUsers = storedUsers.sort((a, b) => b.win - a.win);
    setUsers(sortedUsers);

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    setCurrentUser(currentUser);
    if(currentUser == null){
      navigate("/")
      window.location.reload()
    }
  }, []);

  const columns = [
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Wins',
      dataIndex: 'win',
      key: 'win',
    },
    {
      title: 'Losses',
      dataIndex: 'lose',
      key: 'lose',
    },
    {
      title: 'Draws',
      dataIndex: 'draw',
      key: 'draw',
    },
    {
      title: 'Score',
      dataIndex: 'score',
      key: 'score',
    },
    {
      title: 'Streak',
      dataIndex: 'streak',
      key: 'streak',
    },
  ];

  return (
    <>
      <Navbar />
      <div style={{ padding: 24 }}>
        <h1 style={{color:'white',textAlign:'center'}}>Leaderboard</h1>
        <Table
          columns={columns}
          dataSource={users}
          rowKey="username"
          rowClassName={(record) => record.username === currentUser?.username ? 'current-user-row' : ''}
        />
      </div>
    </>
  );
};

export default Leaderboard;
